<template>
  <el-row>
    <div v-if="error_num">
      <main_panel ref="main_panel"></main_panel>
    </div>
    <div v-else>
      <div style="text-align: center;padding: 20px">
        <img :src="errorpage" style="vertical-align: middle;width: 200px;height: 200px"/>
        <br>
        <br/>
        <span style="color:#6A676F;font-size: 25px;font-weight: bold;">哇哦！数据请求失败</span>
      </div>
    </div>
  </el-row>
</template>

<script>
  import * as API from "@/api/index.js"
  import main_panel from '@/components/monitoring_center/main_panel/index'


  export default {
    components: {
      main_panel
    },
    data() {
      return {
        loading: false,
        data: [],
        error_num: true,
        errorpage: require("@/assets/cry.gif"),
      }

    },
    mounted() {

      this.getData()
        clearInterval(window.$timer);

    },
    methods: {

      async getData() {
        // this.loading = true
        // const response = await API.GET('/omnis/system/home/query_sys_borad_message')
        // if (response && response.data) {
        //   this.error_num = true
        //   let data = response.data
        //   this.data = data.data
        //   this.loading = false
        // } else {
        //   this.loading = false
        //   this.error_num = false
        // }


      },
      fun1() {
        console.log("hello HelloWorld")
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .panel-header {
    background-color: #F2F2F2;
    background: -webkit-linear-gradient(top, #ffffff 0, #F2F2F2 100%);
    background: -moz-linear-gradient(top, #ffffff 0, #F2F2F2 100%);
    background: -o-linear-gradient(top, #ffffff 0, #F2F2F2 100%);
    background: linear-gradient(to bottom, #ffffff 0, #F2F2F2 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff, endColorstr=#F2F2F2, GradientType=0);
  }

  .panel-header, .panel-body {
    border-color: #D4D4D4;
  }

  .panel-header {
    padding: 5px;
    position: relative;
  }

  .panel-header, .panel-body {
    border-width: 1px;
    border-style: solid;
  }

  .panel-title {
    font-size: 12px;
    font-weight: bold;
    color: #777;
    height: 20px;
    line-height: 20px;
  }

  .notice_header {
    width: 99%;
    margin-bottom: 10px;
  }

  .link_title {
    font-size: 12px;
    padding-right: 0px;
    color: dodgerblue;
  }

  .link_title a {
    font-size: 12px;
    padding-right: 0px;
    color: dodgerblue;
    text-underline: dodgerblue;
    text-decoration: underline
  }


</style>



// WEBPACK FOOTER //
// home.vue?4805da0d